'use client';

import type { GlobalHelpCenterSettingsStoryblok } from '@/types/component-types-sb';
import React, { createContext, useContext } from 'react';

interface SettingsProviderProps {
  settings: GlobalHelpCenterSettingsStoryblok;
  children: React.ReactNode;
}

const SettingsContext = createContext<GlobalHelpCenterSettingsStoryblok | null>(null);

const HelpCenterSettingsProvider: React.FC<SettingsProviderProps> = (props) => {
  return <SettingsContext.Provider value={props.settings}>{props.children}</SettingsContext.Provider>;
};

export const useHelpCenterSettings = () => useContext<GlobalHelpCenterSettingsStoryblok | null>(SettingsContext);

export default HelpCenterSettingsProvider;
